module.exports = "/_next/static/images/Functions@3x-b2dd63427e7214c0e1581e7b250a2072.webp";